export default {
  STOCK_MOVEMENTS_LIST: "Liste des mouvements de stock",
  ADD_STOCK_MOVEMENT: "Ajouter un mouvement de stock",
  ADD_STOCK_MOVEMENT_ITEM: "Ajouter une ligne",
  STOCK_MOVEMENT_ADDED: "Mouvement de stock ajouté",
  EDIT_STOCK_MOVEMENT: "Modifier un mouvement de stock",
  STOCK_MOVEMENT_UPDATED: "Mouvement de stock mis à jour",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Choisir un produit",
  DELETE_STOCK_MOVEMENT_ITEM: "Supprimer la ligne",
  UPDATE_STOCK_MOVEMENT_ITEM: "Modifier la ligne",
  STOCK_MOVEMENT_ITEM_DELETED: "Ligne supprimée",
  STOCK_MOVEMENT_ITEM_ADDED: "Ligne ajoutée",
  STOCK_MOVEMENT_ITEM_EDITED: "Ligne modifiée",
  CANCEL: "Annuler",
  REFUND: "Rembourser",
  TYPE_ADD: "Ajouter",
  TYPE_REMOVE: "Retirer",
  TYPE_MOVE: "Déplacer",
  TYPE_CORRECT: "Corriger",
  VALIDATE: "Valider",
  CANCEL: "Annuler",
  STOCK_MOVEMENT_VALIDATED: "Mouvement de stock validé",
  STOCK_MOVEMENT_CANCELED: "Mouvement de stock annulé",
  CANCEL_STOCK_MOVEMENT_QUESTION: "Annuler un mouvement de stock ?",
  DELETE_THIS_STOCK_MOVEMENT_PRODUCT: "Supprimer cette ligne ?",
  DELETE_THIS_STOCK_MOVEMENT: "Supprimer ce mouvement de stock ?",
  STATUS_DRAFT: "Brouillon",
  STATUS_CANCELED: "Annulé",
  STATUS_VALIDATED: "Validé",
  NO_PRODUCT_IN_WAREHOUSE: "Aucun produit dans cet entrepôt",
  PRINT: "Imprimer",
  SELECT_SUPPLIERS: "Choisir les fournisseurs",
  STORAGE_UNIT: "Unité d’inventaire",
  ORDER_UNIT_OF_MEASURE: "Unité de commande",
  CORRECTIONS_CHECK: "Prises d'inventaires",
  CREATE_CORRECTION: "Prendre l'inventaire",
  CORRECTION_CREATED_SUCCESSFULLY: "Prise d'inventaire créée avec succès",
  REQUIRE_PREVIOUS_MONTH_CORRECTION: "La prise d'inventaire du mois précédent est requise",
  REQUIRE_CORRECTION: "Une prise d'inventaire est requise",
  STOCK_MOVEMENT_CORRECT: "Prises d'inventaires",
  CONFIRM_CREATE_TITLE: "Créer une prise d'inventaire",
  CONFIRM_CREATE_TEXT: "Êtes-vous sûr de vouloir créer une prise d'inventaire ?",
  STOCK_MOVEMENT_DELETED: "Mouvement de stock supprimé",
};
